import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from '@mui/material'

interface ConfirmPaymentDialogProps {
    onSubmit: () => void
    onClose: () => void
    open: boolean
    data?: {
        infrastructureFee: number
        payerFee: number
        rhizaFee: number
        total: number
    }
}

const ConfirmPaymentDialog = (props: ConfirmPaymentDialogProps) => {
    const { onSubmit, onClose, open, data } = props

    const renderRow = (label: string, value = 0, total = false) => {
        const cellSx = {
            borderBottom: 'none',
            padding: 0,
            borderTop: total ? '1px solid lightgray' : 'none',
        }
        return (
            <TableRow>
                <TableCell sx={cellSx}>
                    <Typography variant="subtitle1">{label}</Typography>
                </TableCell>
                <TableCell sx={cellSx}>
                    <Typography sx={{ textAlign: 'right' }}>{`${value} RZA`}</Typography>
                </TableCell>
            </TableRow>
        )
    }

    return (
        <Dialog open={open}>
            <DialogTitle>Confirm Payment</DialogTitle>
            <DialogContent>
                <Table>
                    <TableBody>
                        {renderRow('Infrastructure Fee', data?.infrastructureFee)}
                        {renderRow('Payer Fee', data?.payerFee)}
                        {renderRow('Rhiza Fee', data?.rhizaFee)}
                        {renderRow('Total', data?.total, true)}
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button onClick={onSubmit}>Submit Payment</Button>
                <Button onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmPaymentDialog
